<base-support-modal [title]="title" [btnOkClass]="'btn-primary'" [btnOkLabel]="'Установить'" (onOk)="ok()" >
	<p>Выберите сайт-оригинал (который клиент оплачивает):</p>

	<p>
		<select class="form-control" [(ngModel)]="multilangParentId" [ngModelOptions]="{standalone: true}">
			<option *ngFor="let sibling of siblings" [value]="sibling._id" [selected]="sibling._id === multilangParentId" [disabled]="sibling._id==siteId">
				{{ sibling.url }}
			</option>
		</select>
	</p>
</base-support-modal>
